/*
	Copyright (c) 2022 PierceGearhart
	StellaNode Website

	Source code shall not be distributed or modified without
	prior permission from the copyright holder (PierceGearhart) or the
	client (Cyperhost).
*/

// Header
import Header from '../header';
// Images
import Powerful from '../../assets/images/hosting/powerful.svg';
import Secure from '../../assets/images/hosting/secure.svg';
import Affordable from '../../assets/images/hosting/affordable.svg';

function Hero(props) {
    const heroClasses = () => {
        switch(props.type) {
          case 'rust': return 'hero-rust pb-10';
          case 'ark': return 'hero-ark pb-10';
          case 'garrys_mod': return 'hero-garrysmod pb-10';
          case 'hytale': return 'hero-hytale pb-10';
          case 'arma': return 'hero-arma pb-10';
          case 'csgo': return 'hero-csgo pb-10';
          case 'valheim': return 'hero-valheim pb-10';
          default: return 'home-hero mb-10';
        }
      }

    return (
        <div className={heroClasses()}>
            <Header />
            <div className="content max-w-7xl mx-auto px-5 sm:px-5 lg:px-5 pb-36 pt-36">
                <h1 className="text-gray-200 text-5xl font-semibold mb-12">{props.title}</h1>
                <div className='flex flex-wrap items-center mb-9'>
                    <div className='flex items-center text-gray-100 font-semibold text-xl mr-7 w-full sm:w-full md:w-full lg:w-auto mb-3 sm:mb-3 md:mb-3 lg:mb-0'>
                        <img src={Powerful} className='mr-3.5' alt="Powerful" /> Powerful
                    </div>
                    <div className='flex items-center text-gray-100 font-semibold text-xl mr-7 w-full sm:w-full md:w-full lg:w-auto mb-3 sm:mb-3 md:mb-3 lg:mb-0'>
                        <img src={Secure} className='mr-3.5' alt="Secure" /> Secure
                    </div>
                    <div className='flex items-center text-gray-100 font-semibold text-xl w-full sm:w-full md:w-full lg:w-auto'>
                        <img src={Affordable} className='mr-3.5' alt="Affordable" /> Affordable
                    </div>
                </div>
                <p className='text-gray-300'>{props.description}</p>
            </div>
        </div>
    )
}

export default Hero